import Axios from 'axios';
import header from './auth/header'

const API_URL =  process.env.API_URL + '/api/v1/';
const API_URL_V3 = process.env.API_URL + '/api/v3/';

class User {
  index() {
    return Axios.get(API_URL + 'user-list', { headers: header() });
  }

  // show(user) {
  //   return Axios.get(API_URL + `user/${user}`, { headers: header() });
  // }
  show(user) {
    return Axios.get(API_URL_V3 + `auth/me`, { headers: header() });
  }

  updatePassword(data) {
    return Axios.post(API_URL + 'update-password', data, { headers: header() });
  }

  verify(token) {
    return Axios.post(API_URL + 'verify', token, { headers: header() });
  }

  resend(data) {
    return Axios.put(API_URL + 'resend', data, { headers: header() });
  }

  forgotPassword(data) {
    return Axios.post(API_URL + 'forgot-password', data);
  }

  verifyTokenResetPassword(data) {
    return Axios.post(API_URL + 'verify/reset-password', data);
  }
  
  resetPassword(data) {
    return Axios.patch(API_URL + 'reset-password', data);
  }
  
  // Link atur ulang password sekali pakai yang diterbitkan admin.
  // Tanpa header auth: pemiliknya memang belum bisa login.
  checkAdminResetPasswordToken(data) {
    return Axios.post(API_URL_V3 + 'password-reset/check', data);
  }

  submitAdminResetPassword(data) {
    return Axios.post(API_URL_V3 + 'password-reset/submit', data);
  }

  changeDefaultPassword(data) {
    return Axios.post(API_URL + 'change-default-password', data, { headers: header() });
  }
}

export default new User();



// WEBPACK FOOTER //
// ./src/api/user.js